module.exports = __webpack_public_path__ + "static/media/logo-black.e688b3e7.svg";